import { ErrorUtil } from "../../api/ErrorUtil";
import { tryBlock } from "../../cutil/LangUtil";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
import { StoryNodeDisplayType } from "../domain/StoryNodeDisplayType";
import { FuncResponse, FuncResponseType, FunctionBase } from "./FunctionBase";
export class ChatInterfaceFunction extends FunctionBase {
    constructor(brainClient, authStore, meStore, topicService) {
        super(brainClient, authStore);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.meStore = meStore;
        this.topicService = topicService;
    }
    async run(input, identityInfo, ...arg) {
        const type = arg[arg.length - 1];
        let file = input;
        let filename = "";
        let uuid = undefined;
        if (this.isText(type)) {
            /**
             * text node 把文本内容先按text文件类型上传 再处理后续
             * 这里filename只用于chat interface中显示
             */
            filename = "the context";
            const blob = new Blob([input], { type: "text/plain" });
            const formData = new FormData();
            formData.append("file", blob, `text_${+new Date()}.txt`);
            const res = await this.upload(formData);
            file = res?.data?.object_key || null;
            uuid = res?.data?.uuid;
        }
        else if (this.isImagine(type)) {
            const json = tryBlock(() => JSON.parse(input)).data;
            filename = this.fetchFilenameFromUrl(json.value) || "the picture";
            file = json.value;
        }
        else {
            const json = tryBlock(() => JSON.parse(input)).data;
            filename = json.name;
            uuid = json.uuid;
            file = json.s3Path || null;
        }
        const pubsub_topic = await this.topicService.generateTopic(identityInfo, "chatInterface");
        //  file不存在 说明文件上传失败了
        if (file) {
            await this.indexer({
                data: {
                    file,
                    loader: "PDFReader",
                },
                pubsub_topic,
                mode: "chat",
                uuid,
            }, FunctionUtil.createAbortUuid(identityInfo));
            return new FuncResponse(FuncResponseType.CHAT_INTERFACE, {
                file,
                filename,
                pubsub_topic,
                uuid,
                date: +new Date(),
            });
        }
        else {
            throw new Error(ErrorUtil.defaultErrorMsg);
        }
    }
    async indexer(data, uuid) {
        const result = await this.brainClient.openAi.indexers(data, uuid);
        return result;
    }
    async upload(data, uuid) {
        const result = await this.brainClient.openAi.upload(data);
        return result;
    }
    isText(type) {
        return type === StoryNodeDisplayType.TEXT;
    }
    isImagine(type) {
        const supporTypes = [
            StoryNodeDisplayType.IMAGEGEN,
            StoryNodeDisplayType.IMAGESEARCH,
            StoryNodeDisplayType.MIDJOURNEY,
            StoryNodeDisplayType.MIDJOURNEYV2,
        ];
        return supporTypes.includes(type);
    }
    fetchFilenameFromUrl(url) {
        try {
            const urlObject = new URL(url);
            const pathArray = urlObject.pathname.split("/");
            return pathArray[pathArray.length - 1];
        }
        catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
}
